import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'

import './style.scss'

ModalWarning.prototype = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  header: PropTypes.string,
  content: PropTypes.string,
  handleConfirm: PropTypes.func,
}

function ModalWarning(props) {
  const {
    show,
    setShow,
    header,
    content,
    runWhenClosedFunc,
    contentDetails,
    handleConfirm,
    iconTitle,
  } = props

  let handleClose = () => {
    setShow(false)
    if (runWhenClosedFunc) {
      runWhenClosedFunc()
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered className="ModalWarning">
      <Modal.Header closeButton>
        <Modal.Title>
          <span>
            {iconTitle ? (
              iconTitle
            ) : (
              <i
                className="fa-light fa-triangle-exclamation mr-3"
                style={{ fontSize: 20, color: '#ff9f0e' }}
              ></i>
            )}
            {header}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {content}
        <div>{contentDetails}</div>
      </Modal.Body>
      <Modal.Footer>
        {handleConfirm ? (
          <>
            <button
              style={{
                padding: '7px 15px',
                fontSize: '14px',
                fontWeight: 500,
                margin: 0,
              }}
              className="btn btn-outline-secondary mr-4"
              onClick={handleClose}
            >
              Hủy bỏ
            </button>
            <button
              className="btn btn-primary "
              style={{
                backgroundColor: '#304FFD',
                padding: '7px 15px',
                fontSize: '14px',
                fontWeight: 500,
                margin: 0,
              }}
              onClick={(e) => {
                handleClose()
                handleConfirm(e)
              }}
            >
              Đồng ý
            </button>
          </>
        ) : (
          <button
            style={{ padding: '7px 15px', fontSize: '14px', fontWeight: 500 }}
            className="btn btn-outline-secondary"
            onClick={handleClose}
          >
            Đóng
          </button>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default ModalWarning
